import React from 'react';

export const CloseMenuIcon = ({
  color = 'black',
  size = '48',
}: {
  color?: string;
  size?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill={color} />
      <rect
        x="14"
        y="22"
        width="20"
        height="4"
        transform="rotate(45 24 24)"
        fill="#FFFFFF"
      />
      <rect
        x="14"
        y="22"
        width="20"
        height="4"
        transform="rotate(-45 24 24)"
        fill="#FFFFFF"
      />
    </svg>
  );
};
